export const customStylesForPulldowns = {
	// eslint-disable-next-line no-unused-vars
	container: (provided: any, state: any) => ({
		...provided,
		cursor: 'pointer',
		borderRadius: '2px',
		borderColor: 'rgb(198, 220, 217)',
		boxShadow: 'none',
	}),
	// eslint-disable-next-line no-unused-vars
	control: (provided: any, state: any) => ({
		...provided,
		cursor: 'pointer',
		borderColor: 'rgb(198, 220, 217)',
		boxShadow: 'none',
		minHeight: '26px',
		top: '1px',
	}),
	// eslint-disable-next-line no-unused-vars
	placeholder: (provided: any, state: any) => ({
		...provided,
		position: 'relative',
		top: '-2px',
	}),
	// eslint-disable-next-line no-unused-vars
	input: (provided: any, state: any) => ({
		...provided,
		cursor: 'pointer',
		borderColor: 'rgb(198, 220, 217)',
		boxShadow: 'none',
		minHeight: '26px',
	}),
	option: (provided: any, state: any) => ({
		...provided,
		cursor: 'pointer',
		color: state.isSelected ? 'white' : 'black',
		backgroundColor: state.isSelected ? getGraphColor(0) : state.isFocused ? 'rgba(57, 163, 150, 0.25)' : 'inherit',
	}),
	// eslint-disable-next-line no-unused-vars
	valueContainer: (provided: any, state: any) => ({
		...provided,
	}),
	// eslint-disable-next-line no-unused-vars
	multiValue: (provided: any, state: any) => ({
		...provided,
		cursor: 'pointer',
		borderRadius: '4px',
		color: 'white',
		backgroundColor: 'rgb(93,178,165)',
		position: 'relative',
		top: '-2px',
	}),
	// eslint-disable-next-line no-unused-vars
	singleValue: (provided: any, state: any) => ({
		...provided,
		position: 'relative',
		top: '-2px',
	}),
	// eslint-disable-next-line no-unused-vars
	multiValueLabel: (provided: any, state: any) => ({
		...provided,
		color: 'white',
		padding: '1px',
		lineHeight: '20px',
	}),
	// eslint-disable-next-line no-unused-vars
	indicatorsContainer: (provided: any, state: any) => ({
		...provided,
		position: 'relative',
		top: '-3px',
	}),
	// eslint-disable-next-line no-unused-vars
	dropdownIndicator: (provided: any, state: any) => ({
		...provided,
		transform: 'scale(0.75)',
	}),
	// eslint-disable-next-line no-unused-vars
	clearIndicator: (provided: any, state: any) => ({
		...provided,
		transform: 'scale(0.75)',
		padding: 0,
	}),
	// eslint-disable-next-line no-unused-vars
	menu: (provided: any, state: any) => ({
		...provided,
		boxShadow: 'none',
		background: 'white',
		width: 'max-content',
		minWidth: '100%',
	}),
	// eslint-disable-next-line no-unused-vars
	menuList: (provided: any, state: any) => ({
		...provided,
		boxShadow: '0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%)',
		background: 'white',
		textAlign: 'left',
	}),
}

export const getGraphColor = (index: number): string =>
	index > 3 ? 'magenta' : ['#5DB2A5', '#E06161', '#266E69', '#F7CE3F'][index]
